<script lang="ts">
  import { t } from 'svelte-i18n';
</script>

<header>
  <h1 class="mb-6 text-center text-xl font-bold">{$t('ESAF Taxi Flight Quote')}</h1>
</header>

<div class="mt-4 px-2">
  <p class="mt-2">
    {$t('All slots for the ESAF 2025 are fully booked.')}
  </p>
</div>
